<script>
import { Row, Col, Form, Toast, Dialog } from 'vant'
import PickerSelector from '@/components/org/PickerSelector'
import DateTimeSelector from '@/components/org/DateTimeSelector'
import GameTeamSuitSelector from '@/components/org/GameTeamSuitSelector'
import BottomToolbar from '@/components/org/BottomToolbar'
import Game from '@/tbs/model/vo/Game'
import DateTimeFunc from '@/tbs/util/DateTimeFunc'
import ObjectFunc from '@/tbs/util/ObjectFunc'
import { QNImageUtil } from '@/utils'

const game = new Game

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
	name: 'org-game-edit',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-row': Row,
        'van-col': Col,
        'van-form': Form,
        'picker-selector': PickerSelector,
        'date-time-selector': DateTimeSelector,
        'game-team-suit-selector': GameTeamSuitSelector,
        'bottom-toolbar': BottomToolbar,
    },

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
	emits: ['custom-event'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            game: {
                id: null,
                seq: null,
                roundSeq: null,
                roundGroup: null,
                stageId: null,
                startDateTime: null,
                homeTeamId: null,
                homeTeamLogoUrl: null,
                homeTeamSuit: null,
                homeTeamScore: null,
                homeTeamPenaltyScore: null,
                awayTeamId: null,
                awayTeamLogoUrl: null,
                awayTeamSuit: null,
                awayTeamScore: null,
                awayTeamPenaltyScore: null,
            },
            match: {
                matchGroupId: null,
                roundSeq: null,
                roundList: null,
            },
            groupList: null,
            teamList: null,
            isEdit: null,
            isReadonly: null,
            locale: {}
        }
    },
    
    //--------------------------------------------------
    // computed setter and getter
    //--------------------------------------------------
    computed: {
        roundSeqOptions() {
            return game.getRoundSeqOptions(this.match.roundList)
        },
        isGroupRound() {
            // return this.isCurrentGroupRound()
            return this.getCurrentRoundItem().isGroupRound
        },
        homeTeamOptions() {
            console.log('homeTeamOptions', this.teamList)
            const homeTeamList = []
            const teamList = this.teamList || []
            const roundGroup = this.game.roundGroup
            /*const isGroupRound = this.getCurrentRoundItem().isGroupRound
            if (isGroupRound && roundGroup == null) {
                return homeTeamList
            }*/
            for (let i = 0; i < teamList.length; i++) {
                let team = teamList[i]
                if (team.id != this.game.awayTeamId) {
                    // skip the selected away team
                    if (!roundGroup || team.groupId == roundGroup) {
                        // validate the group round
                        homeTeamList.push({
                            label: team.name, 
                            value: team.id,
                            homeTeamSuit: team.homeTeamSuit,
                            awayTeamSuit: team.awayTeamSuit,
                        })
                    }          
                }
            }
            return homeTeamList
        },
        awayTeamOptions() {
            const awayTeamList = []
            const teamList = this.teamList || []
            const roundGroup = this.game.roundGroup
            /*const isGroupRound = this.getCurrentRoundItem().isGroupRound
            if (isGroupRound && roundGroup == null) {
                return awayTeamList
            }*/
            for (let i = 0; i < teamList.length; i++) {
                let team = teamList[i]
                if (team.id != this.game.homeTeamId) {
                    // skip the selected home team
                    if (!roundGroup || team.groupId == roundGroup) {
                        // validate the group round
                        awayTeamList.push({
                            label: team.name, 
                            value: team.id,
                            homeTeamSuit: team.homeTeamSuit,
                            awayTeamSuit: team.awayTeamSuit,
                        })
                    }
                }
            }
            return awayTeamList
        },
        startDateValue() {
            return this.game.startDateTime
        },
        startTimeValue() {
            if (this.game.startDateTime) {
                return DateTimeFunc.formatDate(this.game.startDateTime, 'hh:mm')
            }
            return null
        }
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        onSubmitBtnClick() {
            if (!this.validateSubmitRequired()) {
                // disable to submit and toast the message
                if (!this.game.startDateTime) {
                    Toast(this.locale['game-start-date-time-required'])
                }
                else if (!this.game.homeTeamId) {
                    Toast(this.locale['game-home-team-required'])
                }
                else if (!this.game.awayTeamId) {
                    Toast(this.locale['game-away-team-required'])
                }
            }
            else {
                // enable to submit
                this.submitData()
            }
        },
        onRoundSeqDataChange(data) {
            console.log('onRoundSeqDataChange', data)
            if (data.value == this.game.roundSeq) {
                return
            }
            this.game.roundSeq = data.value
            this.game.stageId = this.getCurrentRoundItem().stageId
            if (!this.getCurrentRoundItem().isGroupRound) {
                this.game.roundGroup = null
            }
            this.$emit('custom-event', {
                type: 'load',
                data: {
                    matchGroupId: this.match.matchGroupId,
                    stageId: this.game.stageId,
                    isGroupRound: this.getCurrentRoundItem().isGroupRound
                }
            })

            if (this.isEdit) {
                this.submitData()
            }
        },
        onRoundGroupDataChange(data) {
            console.log('onRoundGroupDataChange', data)
            if (data.value == this.game.roundGroup) {
                return
            }
            if (!this.isEdit) {
                this.game.roundGroup = data.value
                this.game.homeTeamId = null
                this.game.awayTeamId = null
                this.game.homeTeamSuit = null
                this.game.awayTeamSuit = null
            }
            else {
                // confirm the change
                this.showConfirmDialog('change-round-group', 'roundGroup', data)
            }
        },
        onStartDateTimeDataChange(data) {
            console.log('onStartDateTimeDataChange', data)
            this.game.startDateTime = data
            if (this.isEdit) {
                this.submitData()
            }
        },
        onHomeTeamDataChange(data) {
            console.log('onHomeTeamDataChange', data)
            if (data.value == this.game.homeTeamId) {
                return
            }
            if (!this.isEdit) {
                // change the value directly
                this.game.homeTeamId = data.value
                this.game.homeTeamSuit = data.homeTeamSuit
            }
            else {
                // confirm the change
                this.showConfirmDialog('change-home-team', 'homeTeamId', data)
            }
        },
        onAwayTeamDataChange(data) {
            console.log('onAwayTeamDataChange', data)
            if (data.value == this.game.awayTeamId) {
                return
            }
            if (!this.isEdit) {
                // change the value directly
                this.game.awayTeamId = data.value
                this.game.awayTeamSuit = data.awayTeamSuit
            }
            else {
                // confirm the change
                this.showConfirmDialog('change-away-team', 'awayTeamId', data)
            }
        },
        onHomeTeamSuitDataChange(data) {
            console.log('onHomeTeamSuitDataChange', data.value)
            this.game.homeTeamSuit = data.value
            if (this.isEdit) {
                this.submitData()
            }
        },
        onAwayTeamSuitDataChange(data) {
            console.log('onAwayTeamSuitDataChange', data)
            this.game.awayTeamSuit = data.value
            if (this.isEdit) {
                this.submitData()
            }
        },
        getCurrentRoundItem() {
            const roundSeq = this.game.roundSeq || this.match.roundSeq
            if (roundSeq && this.match.roundList) {
                return this.match.roundList[Number(roundSeq) - 1]
            }
            return {}
        },
        //--------------------------------------------------
        // private method
        //--------------------------------------------------
        /**
         * @private
         * Adjust the image url according to the width and height.
         * @param img The identifier string for the image source.
         * @param w The image width number.
         * @param h The image height number.
         * @return The completed full url string.
         */
		adjustImageSize(img, w, h) {
            // console.log('adjustImageSize', img, w, h)
            if (img) {
                return QNImageUtil.imageView(img, w, h)
            }
			else {
                return null
            }
		},
        validateSubmitRequired() {
            // console.log('validateSubmitRequired')
            if (this.game.startDateTime 
                && this.game.homeTeamId 
                && this.game.awayTeamId) {
                return true
            }
            else {
                return false
            }
        },
        submitData() {
            if (this.validateSubmitRequired()) {
                /*if (this.game.roundSeq == null) {
                    this.game.roundSeq = this.match.roundSeq
                }
                if (this.game.roundTotal == null) {
                    this.game.roundTotal = this.match.roundTotal
                }*/
                if (this.game.stageId == null) {
                    this.game.stageId = this.getCurrentRoundItem().stageId
                }
                this.game.roundSeq = this.getCurrentRoundItem().round
                this.$emit('custom-event', {
                    type: 'submit',
                    data: ObjectFunc.mergeObject(ObjectFunc.cloneObject(this.match), ObjectFunc.cloneObject(this.game), true)
                })
            }
        },
        showConfirmDialog(key, prop, data) {
            console.log('showConfirmDialog', key, prop, data)
            const self = this
            // just set the value if previous is null
            if (this.game[prop] == null) {
                this.game[prop] = data.value
                this.submitData()
                return
            }
            // confirm the change
            Dialog.confirm({
                title: this.locale[key],
                message: this.locale[key + '-confirm-message']
            }).then(() => {
                // on confirm
                // console.log('reverse', reverse)
                console.log('set prop', prop, data)
                this.game[prop] = data.value
                if (prop == 'homeTeamId') {
                    this.game.homeTeamSuit = data.homeTeamSuit
                }
                else if (prop == 'awayTeamId') {
                    this.game.awayTeamSuit = data.awayTeamSuit
                }
                else if (prop == 'roundGroup') {
                    this.game.homeTeamId = null
                    this.game.awayTeamId = null
                    this.game.homeTeamSuit = null
                    this.game.awayTeamSuit = null
                }
                this.game.homeTeamScore = this.game.awayTeamScore = ''
                this.game.homeTeamPenaltyScore = this.game.awayTeamPenaltyScore = ''
                this.submitData()
            }).catch(() => {
                // on cancel
                const originValue = this.game[prop]
                this.game[prop] = data.value
                // delay to restore the value in the next tick
                setTimeout(function() {
                    self.game[prop] = originValue
                }, 200)
            })
        },
    },
}
</script>

<template>
    <div class="game-edit">
        <van-form>
            <picker-selector
                :label="locale['game-round-seq-label']"
                :options="roundSeqOptions"
                :value="match.roundSeq || game.roundSeq"
                :disabled="isReadonly"
                @change-data="onRoundSeqDataChange"
            />
            <picker-selector
                v-if="isGroupRound"
                :label="locale['game-round-group-label']"
                :options="groupList || []"
                :value="game.roundGroup"
                :disabled="isReadonly"
                @change-data="onRoundGroupDataChange"
            />
            <date-time-selector
                :label="locale['game-start-date-label']"
                :datePlaceholder="locale.date"
                :timePlaceholder="locale.time"
                :calendarValue="startDateValue"
                :timeValue="startTimeValue"
                :disabled="isReadonly"
                @change-data="onStartDateTimeDataChange"
            />
            <van-row class="t-outer-margin bg-white">
                <van-col span="12">
                    <picker-selector
                        :label="locale['game-home-team-label']"
                        :options="homeTeamOptions"
                        :value="game.homeTeamId"
                        :disabled="isReadonly"
                        @change-data="onHomeTeamDataChange"
                    />
                </van-col>
                <van-col span="12">
                    <picker-selector
                        :label="locale['game-away-team-label']"
                        :options="awayTeamOptions"
                        :value="game.awayTeamId"
                        :disabled="isReadonly"
                        @change-data="onAwayTeamDataChange"
                    />
                </van-col>
            </van-row>
            <van-row>
                <van-col span="12">
                    <game-team-suit-selector
                        :label="locale['game-home-team-suit-label']"
                        :placeholder="locale['optional']"
                        :value="game.homeTeamSuit"
                        :disabled="isReadonly"
                        :clearable="true"
                        @change-data="onHomeTeamSuitDataChange"
                    />
                </van-col>
                <van-col span="12">
                    <game-team-suit-selector
                        :label="locale['game-away-team-suit-label']"
                        :placeholder="locale['optional']"
                        :value="game.awayTeamSuit"
                        :disabled="isReadonly"
                        :clearable="true"
                        @change-data="onAwayTeamSuitDataChange"
                    />
                </van-col>
            </van-row>
        </van-form>
        <bottom-toolbar 
            v-if="!isEdit"
            type="button" 
            :mainButtonLabel="locale['submit']"
            :mainButtonDisabled="!validateSubmitRequired()"
            @click-main-button="onSubmitBtnClick"
        />
    </div>
</template>